export default __webpack_public_path__ + "static/media/settings.bce153d6.svg";